import { render } from "./RejectedUnfulfilledPurchasesPage.vue?vue&type=template&id=3e232d6e"
import script from "./RejectedUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"
export * from "./RejectedUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__